import * as module from "module";
import {useMediaQuery} from "@mui/material";

/** Как в UIKit_v2.sass: $blue-b3 и радиус %input-v2-unified / .entity-input-v2 */
const UIKIT_V2_FOCUS_BORDER = "1px solid #EF5350"
const UIKIT_V2_INPUT_BORDER_RADIUS = "12px"

export function scrollToElement(elementId: string, highlight: boolean = false) {
    let element = document.getElementById(elementId)
    if (element) {
        element.scrollIntoView({
            behavior: "smooth",
            block: "center"
        })
        if (highlight) {
            highlightElement(element)
        }
    }
}

const MISSING_FIELD_CLASS = "entity-input--missing"

export function clearMissingFieldMarks() {
    if (typeof document === "undefined") {
        return
    }
    document.querySelectorAll(`.${MISSING_FIELD_CLASS}`).forEach((el) => {
        el.classList.remove(MISSING_FIELD_CLASS)
    })
}

export function markMissingFields(keywords: string[]) {
    clearMissingFieldMarks()
    if (typeof document === "undefined") {
        return
    }
    for (const keyword of keywords ?? []) {
        if (!keyword) {
            continue
        }
        const element = document.getElementById(`input.${keyword}`)
        if (element) {
            element.classList.add(MISSING_FIELD_CLASS)
        }
    }
}

export function unmarkMissingField(keyword: string) {
    if (typeof document === "undefined" || !keyword) {
        return
    }
    document.getElementById(`input.${keyword}`)?.classList.remove(MISSING_FIELD_CLASS)
}

/**
 * Скролл к элементу внутри модального окна (Popup): у контейнера .popup__scroll свой overflow,
 * поэтому обычный scrollIntoView по странице не доводит до кнопки внизу формы.
 */
export function scrollElementIntoPopupScrollContainer(elementId: string) {
    const el = document.getElementById(elementId)
    if (!el) {
        return
    }
    const scrollParent = el.closest(".popup__scroll") as HTMLElement | null
    if (scrollParent) {
        const elRect = el.getBoundingClientRect()
        const parentRect = scrollParent.getBoundingClientRect()
        const relativeTop = elRect.top - parentRect.top + scrollParent.scrollTop
        const targetTop =
            relativeTop - parentRect.height / 2 + elRect.height / 2
        scrollParent.scrollTo({
            top: Math.max(0, targetTop),
            behavior: "smooth",
        })
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "center" })
    }
}

export function highlightElement(element: HTMLElement) {
    const borderValue = element.style.getPropertyValue("border")
    const borderRadiusValue = element.style.getPropertyValue("border-radius")
    const transitionValue = element.style.getPropertyValue("transition")

    element.style.setProperty("border-radius", UIKIT_V2_INPUT_BORDER_RADIUS)
    element.style.setProperty("transition", "border-color 0.2s ease")
    element.style.setProperty("border", UIKIT_V2_FOCUS_BORDER)
    setTimeout(() => {
        element?.style.setProperty("border", borderValue)
        element?.style.setProperty("border-radius", borderRadiusValue)
        element?.style.setProperty("transition", transitionValue)
    }, 3000)
}

export function highlightPaymentUrl() {
    const paymentUrlInput = document.getElementById('payment-url-input');
    if (paymentUrlInput) {
        highlightElement(paymentUrlInput);
        paymentUrlInput.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }
}